import _defineProperty from "@babel/runtime/helpers/defineProperty";
import io from 'socket.io-client';
export class SocketIOEventClient {
  constructor() {
    _defineProperty(this, "_socket", void 0);
  }

  connect(url, onError, onSuccess) {
    this._socket = io(url, {
      autoConnect: false,
      reconnection: false,
      withCredentials: true
    });

    this._socket.once('connect', onSuccess);

    this._socket.on('connect_error', onError);

    this._socket.connect();
  }

  emit(event, data) {
    this._socket.emit(event, data);
  }

}
//# sourceMappingURL=socket-io-event-client.js.map